import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconHandshake: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconHandshake"><Path d="M11.8273 5.25646C9.48539 2.91452 5.68836 2.91451 3.34642 5.25645C1.16244 7.44043 0.978512 10.942 3.07886 13.2066C5.85546 16.2002 12.0015 21.25 12.0015 21.25C12.0015 21.25 18.1448 16.2002 20.9214 13.2066C23.0217 10.942 22.8378 7.44043 20.6538 5.25646C18.3119 2.91452 14.5148 2.91452 12.1729 5.25646L7.58687 9.84248L8.69018 10.9458C9.90887 12.1645 11.8847 12.1645 13.1034 10.9458L14.5745 9.47471L19.3516 14.5" stroke="currentColor"/></CentralIconBase>;
});

export default IconHandshake;
